<template>
  <div class="hello">
    <div
      style="width: 40px; border-bottom: 3px solid #0faa9d; margin-bottom: 15px"
    ></div>
    <table class="">
      <tr>
        <td>
          <b>DAY 1</b>
        </td>
        <td>03.00 – 03.30</td>
        <td>Berkumpul di Sukarno Hatta Airport</td>
      </tr>
      <tr>
        <td></td>
        <td>03.30 – 04.30</td>
        <td>Check in & Boarding</td>
      </tr>
      <tr>
        <td></td>
        <td>05.10 – 07.50</td>
        <td>Penerbangan ke Denpasar</td>
      </tr>
      <tr>
        <td></td>
        <td>07.50 – 08.30</td>
        <td>Landing di Ngurah Rai Airport & Menuju Parkiran Bus</td>
      </tr>
      <tr>
        <td></td>
        <td>08.30 – 10.00</td>
        <td>Perjalanan ke Bedugul</td>
      </tr>
      <tr>
        <td></td>
        <td>10.00 – 11.30</td>
        <td>Wisata Pura Ulundanu</td>
      </tr>
      <tr>
        <td></td>
        <td>12.00 – 13.30</td>
        <td>Makan siang & sholat ( Saras )</td>
      </tr>
      <tr>
        <td></td>
        <td>13.30 – 17.00</td>
        <td>Perjalanan & wisata Tanah Lot</td>
      </tr>
      <tr>
        <td></td>
        <td>17.00 – 18.00</td>
        <td>Menuju restoran sunset road</td>
      </tr>
      <tr>
        <td></td>
        <td>18.00 – 19.00</td>
        <td>Makan malam di Grafika Sunset</td>
      </tr>
      <tr>
        <td></td>
        <td>19.00 – 21.00</td>
        <td>Belanja oleh-oleh di Krisna</td>
      </tr>
      <tr>
        <td></td>
        <td>21.00 – 21.30</td>
        <td>Menuju hotel Check in & istirahat</td>
      </tr>
    </table>

    <div
      style="width: 40px; border-bottom: 3px solid #0faa9d; margin-bottom: 15px"
    ></div>
    <table class="">
      <tr>
        <td>
          <b>DAY 2</b>
        </td>
        <td>06.00 – 08.30</td>
        <td>Sarapan & prepare check out</td>
      </tr>
      <tr>
        <td></td>
        <td>08.30 - 11.30</td>
        <td>
          Meninggalkan hotel & menuju parkir bis dilanjutkan wisata ke Pantai
          Kuta ( ganti transport )
        </td>
      </tr>
      <tr>
        <td></td>
        <td>12.00 – 13.00</td>
        <td>Makan Siang</td>
      </tr>
      <tr>
        <td></td>
        <td>13.00 – 15.00</td>
        <td>*Optional : JOGER Tuban</td>
      </tr>
      <tr>
        <td></td>
        <td>15.00 – 15.30</td>
        <td>Menuju Bandara Ngurah Rai</td>
      </tr>
      <tr>
        <td></td>
        <td>15.30 – 17.30</td>
        <td>Check in & boarding</td>
      </tr>
      <tr>
        <td></td>
        <td>18.00 – 20.00</td>
        <td>Penerbangan ke Jakarta</td>
      </tr>
      <tr>
        <td></td>
        <td>20.00 – 20.30</td>
        <td>Tiba di Sukarno Hatta Airport</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "Jogja",
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table td span {
  border-top: 3px solid #0faa9d;
}
table td {
  font-size: 14px;
  vertical-align: top;
  padding-bottom: 10px;
}
table td:nth-child(1) {
  width: 50px;
}
table td:nth-child(2) {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/LampungJakarta.vue